import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import Comment from 'components/common/Comment/index';
import SendComment from 'components/common/CommentSend/index';
import {getComments, addComment, delComment, setComment} from 'api/debtCollectionMonitor';
import {modalShow, modalHide} from 'actions/modal';
import styles from './styles.module.sass';
import CommentEdit from 'components/common/CommentEdit/index';

const mapStateToProps = state => ({
  user: state.user
});

@connect(mapStateToProps)
class CollectionCaseComments extends PureComponent {
  state = {
    total: 0,
    page: 1,
    count: 0,
    items: []
  };

  componentDidMount() {
    this.loadComments();
  }

  loadComments() {
    const {collectionCaseId} = this.props;
    getComments(collectionCaseId)
      .then((data) => this.setState(data));
  }

  handlerOnCommentSending = (text, publicFlag) => {
    const {collectionCaseId, user: {id: personId}} = this.props;
    addComment({collectionCaseId, text, publicFlag, personId})
      .then(() => this.loadComments());
  };

  handlerOnRemoveComment = (commentId) => {
    const {collectionCaseId, user: {id: personId}} = this.props;
    delComment({collectionCaseId, personId, commentId})
      .then(() => this.loadComments());
  };

  handlerOnEditComment = (commentId, {text, forAll}) => {
    const {dispatch, collectionCaseId, user: {id: personId}} = this.props;

    dispatch(modalShow(<CommentEdit
      onCancel={() => dispatch(modalHide())}
      onSend={(txt, frAll) => {
        setComment({collectionCaseId, personId, commentId, publicFlag: frAll, text: txt})
          .then(() =>
            {
              dispatch(modalHide());
              this.loadComments();
            }
          );
      }}
      defaultForAll={forAll}
      defaultText={text}
    />));
  };

  render() {
    const {items = []} = this.state;

    return (
      <div className={styles.box}>
        <SendComment placeholder='Оставить комментарий' classes={styles.commentNew} onSend={this.handlerOnCommentSending}/>
        {items.map((item) =>
          <Comment
            key={`comment-${item.id}`}
            author={item.author}
            date={item.time}
            changeDate={item.changeDate}
            changePersonName={item.changePersonName}
            publicFlag={item.publicFlag}
            onRemove={() => this.handlerOnRemoveComment(item.id)}
            onEdit={() => this.handlerOnEditComment(item.id, {text: item.text, forAll: item.publicFlag})}
          >
            {item.text}
          </Comment>
        )}
      </div>
    );
  }
}

CollectionCaseComments.propTypes = {
  collectionCaseId: PropTypes.string
};

export default CollectionCaseComments;


// WEBPACK FOOTER //
// ./src/components/page/CollectionCase/CollectionCaseComments/CollectionCaseComments.jsx